import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Button, ButtonTypes, Tooltip } from 'src/presentation/components/agent_desktop_components';

const ActionButton = ({
  'data-aid': dataAid,
  children,
  className,
  disabled,
  onClick,
  title,
}: {
  'data-aid'?: string;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick: (e) => void;
  title?: string;
}) => {
  return (
    <Tooltip message={title}>
      <StyledButton
        className={className}
        data-aid={dataAid}
        disabled={disabled}
        onClick={onClick}
        type={ButtonTypes.TEXT}
      >
        {children}
      </StyledButton>
    </Tooltip>
  );
};

export const StyledButton = styled(Button)`
  border-radius: 0.25rem;
  padding: 0.5rem;
  position: relative;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    z-index: 1;
    fill: ${p => p.theme.colors.gray700};
  }
`;

export default ActionButton;
